'use client';

import { XIcon } from 'lucide-react';
import React from 'react';
import { Button } from '../ui/button';
import { type Website } from '~/fecom-api/schema';
import { useSearchParams } from 'next/navigation';

type SiteInformationBannerProps = {
  isInternational: boolean;
  countryCode: string | null;
  isTransactionalSite: boolean;
  userCurrency: string | null;
  websiteId: Website;
  username?: string;
  priceGroup?: string | null;
};

export function SiteInformationBanner({
  isInternational,
  countryCode,
  isTransactionalSite,
  userCurrency,
  websiteId,
  username,
  priceGroup,
}: SiteInformationBannerProps) {
  const params = useSearchParams();

  const show = params.has('debug');

  const [showBanner, setShowBanner] = React.useState(show);

  if (!showBanner) {
    return null;
  }

  return (
    <div className="z-overlay mx-auto mb-1 flex items-center justify-center gap-2 rounded-lg bg-neutral-200 p-1 text-neutral-700">
      <div className="flex max-w-full flex-wrap items-center justify-center text-center text-sm [&>*]:p-2">
        <div>Website: {websiteId}</div>
        <div>isInternational: {isInternational ? 'Yes' : 'No'}</div>
        <div>countryCode: {countryCode ? countryCode : 'Unknown'}</div>
        <div>userCurrency: {userCurrency ? userCurrency : 'Unknown'}</div>
        <div>isTransactionalSite: {isTransactionalSite ? 'Yes' : 'No'}</div>
        {username && <div>Username: {username}</div>}
        {priceGroup && <div>Price Group: {priceGroup}</div>}
      </div>
      <div>
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6"
          onClick={() => setShowBanner(false)}
        >
          <XIcon className="size-4" />
        </Button>
      </div>
    </div>
  );
}
